import styled from 'styled-components';

interface TabProps {
  isActive: boolean;
  text: string;
  handleClick: () => void;
}

export const Tab = ({ isActive, text, handleClick }: TabProps) => {
  return (
    <Container onClick={handleClick}>
      <TabText isActive={isActive}>{text}</TabText>
    </Container>
  );
};

const Container = styled.button`
  min-width: 80px;
  height: 28px;

  display: flex;
  justify-content: center;
  align-items: center;

  flex: 1 0 0;
  padding: 8px 16px 24px 16px;
  gap: 10px;

  transition: all 0.3s ease;
`;

const TabText = styled.span<{ isActive: boolean }>`
  color: ${(props) => (props.isActive ? '#232429' : '#A7A9B6')};
  text-align: center;

  /* System/Medium/m-bold */
  font-family: Pretendard;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: 85%; /* 11.9px */
`;
